import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="highlight-box"> <strong>Effective Date:</strong> April 1, 2025</p>

      <h2>Introduction</h2>
      <p>
        Welcome to Smart Rainmakers! We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our decentralized crowdfunding system. The system empowers you as either donors/givers and receivers, to use the online donation-based crowdfunding platform, intellectual property, features, and benefits for their personal benefit.
      </p>

      <h2>1. Information We Collect</h2>
      <h3>1.1 Personal Information</h3>
      <ul>
        <li><strong>Account Information:</strong> When you create an account, we collect your email address, password, and wallet address.</li>
        <li><strong>Transaction Information:</strong> Details of transactions you carry out through our platform, including amounts and timestamps.</li>
      </ul>

      <h3>1.2 Non-Personal Information</h3>
      <ul>
        <li>We do not collect IP addresses, browser types, or any other device information.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <h3>2.1 To Provide and Maintain Our Service</h3>
      <ul>
        <li>To create and manage your account.</li>
        <li>To process and facilitate transactions.</li>
        <li>To provide customer support.</li>
      </ul>

      <h3>2.2 To Improve Our Service</h3>
      <ul>
        <li>To understand how you use our platform and identify areas for improvement.</li>
        <li>To personalize your experience.</li>
      </ul>

      <h3>2.3 Legal and Compliance</h3>
      <ul>
        <li>To comply with legal obligations and regulatory requirements.</li>
        <li>To protect our rights and enforce our terms of service.</li>
      </ul>

      <h2>3. Information Sharing and Disclosure</h2>
      <h3>3.1 Third-Party Service Providers</h3>
      <p>We may share your information with third-party service providers who assist us in operating our platform, such as payment processors and analytics providers.</p>

      <h3>3.2 Legal Requirements</h3>
      <p>We may disclose your information if required to do so by law or in response to valid requests by public authorities.</p>

      <h3>3.3 Business Transfers</h3>
      <p>In the event of a merger, acquisition, or asset sale, your information may be transferred to a new owner.</p>

      <h2>4. Security</h2>
      <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no internet-based platform can be completely secure, and we cannot guarantee the absolute security of your data.</p>

      <h2>5. Your Rights</h2>
      <h3>5.1 Access and Correction</h3>
      <p>You have the right to access and update your personal information.</p>

      <h3>5.2 Data Portability</h3>
      <p>You have the right to request a copy of your personal data in a structured, commonly used, and machine-readable format.</p>

      <h3>5.3 Deletion</h3>
      <p>You have the right to request the deletion of your personal information, subject to certain legal and regulatory obligations.</p>

      <h2>6. Changes to This Privacy Policy</h2>
      <p>
        We reserve the right, at any time and without notice, to add to, change, update, or modify this Privacy Policy, simply by posting such change, update, or modification on the Site and without any other notice to you. Any such change, update, or modification will be effective immediately upon posting on the Site. In the event of substantive changes to this Privacy Policy, the new terms will be posted to the Site, you will be required to affirmatively assent to its terms, and you may also be notified by email. If any modification is unacceptable to you, your only recourse is not to use the Site and Service and to request an immediate termination of your membership. Your express consent or continued use of the Site or our Service following posting of a change notice or new Privacy Policy on the Site will constitute binding acceptance of the changes.
      </p>

      <p><strong>YOUR USE OF OUR SITE MEANS THAT YOU ACCEPT THE PRACTICES SET FORTH IN THIS POLICY. YOUR CONTINUED USE INDICATES YOUR AGREEMENT TO THE CHANGES</strong></p>

      <h2>7. Contact Us</h2>
      <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
      <p>Email: info@smartrainmakers.com</p>
    </div>
  );
};

export default PrivacyPolicy;
